<template>
    <table>
        <tbody>
            <template v-if="myCartList.length">
                <tr
                    v-for="item in myCartList"
                    :key="`${item.product_id}-${item.storage_id}`"
                >
                    <template v-if="item.valid">
                        <td>
                            <div :style="coverImage(item)"></div>
                        </td>
                        <td>
                            <div>
                                <div>{{ item.name }} {{ item.specname }}</div>
                                <div>NT{{ item.amount }}</div>
                            </div>
                        </td>
                        <td>
                            <cart-quantity :cart-item="item"></cart-quantity>
                        </td>
                        <td>
                            <cart-remove-btn
                                :cart-item="item"
                            ></cart-remove-btn>
                        </td>
                    </template>
                    <template v-else>
                        <td colspan="6">商品已下架或刪除</td>
                    </template>
                </tr>
            </template>
            <template v-else>
                <tr>
                    <td colspan="6">No any item in cart.</td>
                </tr>
            </template>
        </tbody>
    </table>
</template>
<script>
    import eventHub from "../../../library/event-hub";

    export default {
        props: {
            cartList: {
                default: undefined,
            },
        },
        data() {
            return {
                myCartList: [],
            };
        },
        watch: {
            cartList: {
                deep: true,
                handler(newValue, oldValue) {
                    this.myCartList = newValue;
                },
            },
        },
        mounted() {
            if (this.cartList) this.myCartList = this.cartList;
            else this.loadCartList();
            eventHub.$on("cart-updated", (newList) => (this.myCartList = newList));
        },
        methods: {
            coverImage(item) {
                let default_url = `url(${base_url}/static-files/tom/images/ct01.jpg)`;
                let result_url = item.image ? `url(${item.image})` : default_url;
                return { "background-image": result_url };
            },
            loadCartList() {
                console.log("load cart list.");
                let api_url = `${base_url}/api/carts`;
                axios
                    .get(api_url)
                    .then((success_response) => {
                        this.myCartList = success_response.data;
                        // console.log(success_response);
                    })
                    .catch((e) => {
                        let error_response;
                        if (e.isAxiosError) {
                            error_response = e.response;
                            console.log(error_response);
                        } else {
                            console.log([e]);
                        }
                    });
            },
        },
        computed: {
            totalAmount() {
                if (this.myCartList instanceof Array && this.myCartList.length) {
                    let result = 0;
                    this.myCartList.forEach((item) => (result += item.amount));
                    return result;
                } else {
                    return 0;
                }
            },
        },
        filters: {
            currency(value) {
                return `NT$ ${value}`;
            },
        },
    };
</script>
<style lang="">
</style>